import { useGetAnalysisTemplateDetail } from "@/api/analysis/useAnalysisAPI";
import { Template } from "@/types/template";

import LoadingShimmerTemplate from "../LoadingShimmerTemplate";
import TemplateOverviewModalConfiguration from "./Configuration";
import TemplateOverviewModalHeader from "./Header";
import TemplateSummaryModal from "./Summary";

interface TemplateOverviewModalProps {
  readonly selectedTemplate: Template;
}

export default function TemplateOverviewModal({
  selectedTemplate
}: TemplateOverviewModalProps) {
  const { data: templateDetail, isLoading } = useGetAnalysisTemplateDetail(
    selectedTemplate.id
  );

  return (
    <div className="flex flex-col gap-4 py-4 px-6 overflow-auto max-h-[600px]">
      {templateDetail && !isLoading ? (
        <>
          <TemplateOverviewModalHeader title={templateDetail?.title} />

          <div className="grid grid-cols-2 gap-6">
            <TemplateSummaryModal templateDetail={templateDetail} />
            <TemplateOverviewModalConfiguration
              templateDetail={templateDetail}
            />
          </div>
        </>
      ) : (
        <LoadingShimmerTemplate />
      )}
    </div>
  );
}
